export const shiftModalGeneralTabValueTextMarginLeft = 16;
